export default __webpack_public_path__ + "static/xsearch_product-1835e5761433aa88179b5810f5a58039.png";